import { api } from '../api';

/**
 * Vincula o atendimento ao alerta e o tira da fila.
 *
 * ⚠️ O `appointmentId` e **obrigatorio**, e nao e detalhe de implementacao: a spec
 * diz que "Tratar alerta" sempre abre um atendimento, e o contrato do back exige o
 * id justamente para que nao exista caminho de tratar sem um. Quem cria o
 * atendimento e o fluxo de "Atender agora" que a tela ja tem.
 */
export const treatAlert = async (
  alertId: string,
  appointmentId: string,
): Promise<void> => {
  await api.post(`/alerts/${alertId}/treat`, { appointmentId });
};
